import React from 'react';
import { TerrainType } from '@/lib/types/core/terrain';
import * as Icons from './icons';

const iconMap: Record<TerrainType, React.FC<{ className?: string; size?: number }>> = {
  "deep-water": Icons.DeepWaterIcon,
  "shallow-water": Icons.ShallowWaterIcon,
  "hill-climb-or-descent": Icons.HillClimbOrDescentIcon,
  "unknown": Icons.UnknownIcon,
  "deep-ruts": Icons.DeepRutsIcon,
  "smooth-gravel": Icons.SmoothGravelIcon,
  "embedded-rock": Icons.EmbeddedRockIcon,
  "loose-rock": Icons.LooseRockIcon,
  "rock-garden": Icons.RockGardenIcon,
  "mud": Icons.MudIcon,
  "sand": Icons.SandIcon,
  "whoops": Icons.WhoopsIcon,
  "washboard": Icons.WashboardIcon,
  "twisties": Icons.TwistiesIcon,
  "switchbacks": Icons.SwitchbacksIcon,
  "dunes": Icons.DunesIcon,
  "obstacles": Icons.ObstaclesIcon,
  "fast": Icons.FastIcon,
  "slow-technical": Icons.SlowTechnicalIcon,
  "single-track": Icons.SingleTrackIcon,
  "double-track": Icons.DoubleTrackIcon,
  "public-roads": Icons.PublicRoadsIcon,
  "highway": Icons.HighwayIcon,
  "woods": Icons.WoodsIcon,
};

interface TerrainIconProps {
  terrain: TerrainType;
  size?: number;
  className?: string;
}

export const TerrainIcon: React.FC<TerrainIconProps> = ({ terrain, size = 24, className }) => {
  const Icon = iconMap[terrain];
  if (!Icon) return null;
  return <Icon size={size} className={className} />;
};
